import { useState } from 'react';

interface Props {
  content: string;
}

export default function ParagraphsExpand(props: Props) {
  const [ expanded, setExpanded ] = useState<boolean>(false);

  // Split text on double newlines (paragraphs)
  let inputSplit = props.content.split(/\n\n/);

  // Add <br> tags on single newlines
  inputSplit = inputSplit.map(part => {
    return part.replace(/\n/, '<br>');
  });

  return (
    <>
      {
        inputSplit.map((part, partIndex) =>
          (partIndex === 0 || expanded) && (
            <p key={ partIndex }>
              <span dangerouslySetInnerHTML={ { __html: part } } />
              { (partIndex === 0 && partIndex === inputSplit.length && !expanded) &&
                <> <a onClick={ () => setExpanded(!expanded) }>Read more</a></>
              }
            </p>
          )
        )
      }
    </>
  );
}
